import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {Chart} from 'angular-highcharts';
import {IntelligenceData} from '../../../models/intelligence-data.interface';
import {INTELLIGENCE_PIE_COLORS} from '../../../../constants/charts';
import {PointOptionsObject} from 'highcharts';
import {MessageService} from '../../../../shared/services/message.service';
import {Router} from '@angular/router';
import {AuthService} from '../../../../core/services/auth.service';

@Component({
  selector: 'app-employees-per-pro-pie-chart',
  templateUrl: './employees-per-pro-pie-chart.component.html',
  styleUrls: ['./employees-per-pro-pie-chart.component.scss']
})
export class EmployeesPerProPieChartComponent implements OnInit, OnChanges {

  textBelow!: string;
  chart!: Chart;
  chartData!: any[];
  pieCategories!: string[];
  textBelowCode = 'intelligence.WeeeSystem.EmployeesPerPro.textBelow';
  isAdmin!: boolean;

  @Input()
  data!: IntelligenceData[];
  @Input()
  displayUnits!: string;
  @Input()
  title!: string;
  @Input()
  subtitle!: string;

  private static getPieCategories(chartData: IntelligenceData[]): string[] {
    const pieCategories = chartData.map(item => item.answer);
    return [...new Set(pieCategories)];
  }

  constructor(private readonly messageService: MessageService,
              private readonly router: Router,
              private authService: AuthService) {
  }

  ngOnInit(): void {
    this.isAdmin = this.authService.getUserRoles().includes('WF_ADMIN');
    this.messageService.getDialogInfo(this.textBelowCode).subscribe((data) => {
      if (data !== null) {
        this.textBelow = data.description;
      }
    });
  }

  ngOnChanges(): void {
    if (this.data) {
      this.pieCategories = EmployeesPerProPieChartComponent.getPieCategories(this.data);
      this.chartData = this.convertToChartData();
      this.chart = new Chart({
        chart: {
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        colors: INTELLIGENCE_PIE_COLORS,
        title: {
          text: this.title
        },
        subtitle: {
          text: this.subtitle
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: true,
              format: '{point.name}'
            }
          }
        },
        exporting: {
          enabled: true
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          formatter(): string[]|undefined {
            if (this.point.name) {
              const pointOptions = this.point as PointOptionsObject;
              if (pointOptions.custom?.absolute === 0) {
                return [this.point.name];
              }
              return ['<div class="center"><b>' + this.point.name + '</b></div><br><br>',
                '- Total responses: ' + pointOptions.custom?.totalResponses + '<br>',
                '- Total sum of respondents: ' + pointOptions.custom?.totalSumStaff + '<br>',
                '- Average: ' + pointOptions.custom?.average + '%<br>'
              ];
            }
            // If not null, use the default formatter
            // return tooltip.defaultFormatter.call(this, tooltip);
            return undefined;
          }
        },
        series: [{
          name: 'Value (%)',
          type: 'pie',
          data: this.chartData
        }]
      });
    }
  }

  editTextBelow(): void {
    this.router.navigate(['/admin/chart-labels'], {state: { code: this.textBelowCode }}).then(
      () => {
        // do nothing
      }
    );
  }

  private convertToChartData(): any[] {
    this.chart?.ref?.hideData();
    const chartData: any[] = [] ;
    this.data.forEach(item => {
      chartData.push({
        y: Number(((item.totalResponses / item.totalAdditionResponses) * 100).toFixed(2)),
        name: item.answer,
        custom: {
          totalResponses: item.totalResponses,
          totalSumStaff: item.totalAdditionResponses,
          average: Number(((item.totalResponses / item.totalAdditionResponses) * 100).toFixed(2))
        }
      });
    });
    return chartData;
  }

}
